import { render } from "./UserCrud.vue?vue&type=template&id=3fd8f0d7"
import script from "./UserCrud.vue?vue&type=script&lang=js"
export * from "./UserCrud.vue?vue&type=script&lang=js"
script.render = render

export default script